import { withinRange } from '../../dateUtils';
import { DataRow, DataTable, DateRange, ValueAccessor } from '../../models';
import { DefaultTimestampAccessor } from '../../models/Accessor';

// apply a fully inclusive date range window to the provided metricTable

export const applyDateRangeWindow = (
  metricTable: DataTable,
  dateRange: DateRange | undefined,
  timestampAccessor: ValueAccessor<Date> = DefaultTimestampAccessor
): DataTable => {
  if (!dateRange) {
    return metricTable;
  }
  let windowedMetric: DataRow[] = [];
  metricTable.forEach((point) => {
    if (withinRange(dateRange, timestampAccessor(point))) {
      windowedMetric.push(point);
    }
  });
  return windowedMetric;
};
